export default "__VITE_ASSET__MyGil4VB__"